import React, { useEffect, useState } from "react";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { Link, useNavigate, NavLink } from "react-router-dom";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid2";
import Typography from "@mui/material/Typography";
import "./Login.css";
import {
  chipClasses,
  Experimental_CssVarsProvider,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import FormControl from "@mui/material/FormControl";
// import TextField from '@mui/material/TextField';
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import IconButton from "@mui/material/IconButton";
// import Button from '@mui/material/Button';
// import Typography from '@mui/material/Typography';
import Modal from "@mui/material/Modal";
// import usercalls from "../../Axios";
// import consts from "../../constant";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import LoginBtn from "./LoginBtn";

import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import NativeSelect from "@mui/material/NativeSelect";
// import AuthHeader from "./AuthHeader";
import AuthLeft from "./AuthLeft";
import { Register } from "../../services/auth";
import { all } from "axios";
// import Loader from "../Loader";
// import Checkbox from '@mui/material/Checkbox';

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "#fff",
  // border: '2px solid #000',
  boxShadow: 24,
  borderRadius: "10px",
  outline: "none",
  "@media(max-width:767.98px)": {
    width: "75%",
  },
  p: 4,
};

const label = { inputProps: { "aria-label": "Checkbox demo" } };

export default function SignInSide() {
  const theme = useTheme();
  const md = useMediaQuery(theme.breakpoints.up("md"));
  const lg = useMediaQuery(theme.breakpoints.up("lg"));

  const navigate = useNavigate();

  const [showPassword, setShowPassword] = React.useState(false);

  // const handleClickShowPassword = () => setShowPassword((show) => !show);

  const [showConfirmPassword, setShowConfirmPassword] = React.useState(false);

  // const handleClickConfirmShowPassword = () =>
  //   setShowConfirmPassword((show) => !show);
  const [allUsers, setAllUsers] = useState({
    firstname: "",
    lastname: "",
    email: "",
    password: "",
    confirmpassword: "",
    registercheck: false,
  });

  const [errors, setErrors] = useState({
    firstname: "",
    lastname: "",
    email: "",
    password: "",
    confirmpassword: "",
    registercheck: "",
  });

  const [load, setLoad] = useState(false);
  const [emailError, setEmailError] = useState(null);

  const [check, setCheck] = useState(false);
  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleClickShowConfirmPassword = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setErrors({
      ...errors,
      [name]: "",
    });

    if (name === "email") {
      if (!/\S+@\S+\.\S+/.test(value)) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          email: "Email is invalid",
        }));
      } else {
        setErrors((prevErrors) => ({
          ...prevErrors,
          email: "",
        }));
      }
    }
    // // Password validation
    // if (name === "password") {
    //   if (name === "password" && value != "" && value.length < 6) {
    //     const errorMessage = "Password must be at least 6 characters long";
    //     setErrors((prevErrors) => ({
    //       ...prevErrors,
    //       password: errorMessage,
    //     }));
    //   }
    //   if (name === "password" && value != "" && !/^[A-Z]/.test(value)) {
    //     const errorMessage = "Password must start with a capital letter";
    //     setErrors((prevErrors) => ({
    //       ...prevErrors,
    //       password: errorMessage,
    //     }));
    //   }

    // } else {
    //   setErrors((prevErrors) => ({
    //     ...prevErrors,
    //     password: "",
    //   }));
    // }

    setAllUsers((prevState) => ({ ...prevState, [name]: value }));
  };

  const handleKeyPress = (e) => {
    const { name } = e.target;

    // Prevent spaces, tab spaces, and numbers from being entered
    if (/\d|\s|\t/.test(e.key)) {
      e.preventDefault(); // Stop the input from being added to the field
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: `${name} should not contain spaces, tab characters, or numbers.`,
      }));
    } else {
      // Clear the error message when the user starts typing a valid character
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "",
      }));
    }
  };
  const validateFocus = (e) => {
    const passwordRegex = /^(?=.*[A-Z])(?=.*[!@#$%^&*])(?=.*[0-9]).{6,}$/;
    const fieldName = e?.target?.name;
    const fieldValue = e?.target?.value;
    const value = fieldValue.trim();

    let isValid = true;

    let errorMessage = "";

    // Handle empty field validation
    // if (value === "" || value === undefined) {
    //   if (fieldName === "firstname") {
    //     errorMessage = `First Name is required`;
    //     isValid = false;
    //   }
    //   if (fieldName === "lastname") {
    //     errorMessage = `Last Name is required`;
    //     isValid = false;
    //   }
    // }

    // Handle email validation
    if (fieldName === "email") {
      if (value === "" || value === undefined) {
        // errorMessage = "Email is required";
        // isValid = false;
      } else if (!/\S+@\S+\.\S+/.test(fieldValue)) {
        errorMessage = "Email is invalid";
        isValid = false;
      }
    }
    if (fieldName === "password") {
      if (value === "" || value === undefined) {
        // errorMessage = "Password is required";
        // isValid = false;
      }
      if (!passwordRegex.test(value) && value != "") {
        errorMessage =
          "Password must contain at least 6 characters, one uppercase letter, one special character, and one number";
        isValid = false;
      }
    }
    if (fieldName === "confirmpassword") {
      // if (value === "" || value === undefined) {
      //   // errorMessage = "Confirm Password is required";
      //   // isValid = false;
      // } else
       if (allUsers.password != fieldValue) {
        errorMessage = "Confirm Password does not match";
        isValid = false;
      }
    }
    // if (fieldName === "password") {
    //   errorMessage = "Password is required";
    //   isValid = false;
    // }
    // if (fieldName === "confirmpassword") {
    //   errorMessage = "Password is required";
    //   isValid = false;
    // } else if (allUsers.password != value  && value === "" && value === undefined) {
    //   errorMessage = "Confirm Password does not match";
    //   isValid = false;
    // }

    // Set errors after validation
    setErrors((prevErrors) => ({
      ...prevErrors,
      [fieldName]: errorMessage,
    }));

    return isValid;
  };

  const validate = () => {
    let formErrors = {};
    let isValid = true;

    // Validate first name
    if (!allUsers.firstname) {
      formErrors.firstname = "First Name is required";
      isValid = false;
    }

    // Validate last name
    if (!allUsers.lastname) {
      formErrors.lastname = "Last Name is required";
      isValid = false;
    }

    // Validate email
    if (!allUsers.email) {
      formErrors.email = "Email is required";
      isValid = false;
    } else if (!/\S+@\S+\.\S+/.test(allUsers.email)) {
      formErrors.email = "Email is invalid";
      isValid = false;
    }

    // Validate password
    if (!allUsers.password) {
      formErrors.password = "Password is required";
      isValid = false;
    } else if (allUsers.password.length < 6) {
      formErrors.password = "Password must be at least 6 characters long";
      isValid = false;
    } else if (!/^[A-Z]/.test(allUsers.password)) {
      formErrors.password = "Password must start with a capital letter";
      isValid = false;
    }

    // Confirm password validation
    if (allUsers.password !== allUsers.confirmpassword) {
      formErrors.confirmpassword = "Passwords do not match";
      isValid = false;
    }
    if (!allUsers.confirmpassword) {
      formErrors.confirmpassword = "Confirm Password is required";
      isValid = false;
    }
    if (allUsers.registercheck === false) {
      formErrors.registercheck = "Please fill the terms and service";
      isValid = false;
    }

    setErrors(formErrors);
    return isValid;
  };

  // Handle submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      setLoad(true);
      const response = await Register(allUsers);
      if (response?.data?.success === true) {
        setLoad(false);
        toast.success("Signup Successfully...!");
        setTimeout(() => {
          navigate("/success", { state: { email: allUsers.email } });
        }, 1000);
      } else {
        toast.error(response?.data?.message);
        setLoad(false);
      }
      // toast.success("Form submitted successfully!");
      // Proceed with form submission logic (e.g., sending data to the server)
    }
  };
  return (
    <>
      {/* <AuthHeader /> */}
      {/* <Loader/> */}
    <ToastContainer  
          autoClose={2000}
        />
      <div className="register">
        <Grid
          container
          component="main"
          spacing={2}
          sx={{ alignItems: "flex-start", pt: 0 }}
          className={!md ? "medium" : ""}
        >
          <Grid size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
            <AuthLeft />
          </Grid>
          <Grid size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
            <Grid
              container
              sx={{
                justifyContent: "center",
                alignItems: "center",
                width: md ? "600px" : "auto",
                margin: "0 auto",
                height: "100vh",
              }}
            >
              <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
                <Box
                  sx={{
                    my: md && 3,
                    marginRight: 4,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    // padding: "28px 25px",
                  }}
                  // className={!md && "log-bcg"}
                >
                  <h2 className="c-accout">Sign Up</h2>
                  {/* <LoginBtn /> */}

                  <Box sx={{ mt: 4, width: md ? "100%" : "90%" }}>
                    <Grid container spacing={2}>
                      <Grid size={{ xs: 12, sm: 12, md: 6, lg: 6 }}>
                        <div className="input-common">
                          <label>First Name</label>
                          <TextField
                            fullWidth
                            id="fullWidth"
                            placeholder="First Name"
                            name="firstname"
                            onChange={(e) => handleChange(e)}
                            onFocus={(e) => validateFocus(e)}
                            value={allUsers.firstname}
                            type="text"
                            onKeyPress={handleKeyPress} // Prevent invalid characters
                            error={!!errors.firstname}
                            onInput={validateFocus}
                            helperText={errors.firstname}
                            // error={!!errors.firstName}
                            // helperText={errors.firstName}
                          />
                          {/* {errors.firstname && (
                            <span className="error" style={{ color: "red" }}>
                              {errors.firstname}
                            </span>
                          )} */}
                        </div>
                      </Grid>
                      <Grid size={{ xs: 12, sm: 12, md: 6, lg: 6 }}>
                        <div className="input-common">
                          <label>Last Name</label>
                          <TextField
                            fullWidth
                            id="fullWidth"
                            placeholder="Last Name"
                            name="lastname"
                            onChange={(e) => handleChange(e)}
                            onFocus={(e) => validateFocus(e)}
                            value={allUsers.lastname}
                            type="text"
                            error={!!errors.lastname}
                            helperText={errors.lastname}
                            onInput={validateFocus}
                          />
                          {/* {errors.lastname && (
                            <span className="error" style={{ color: "red" }}>
                              {errors.lastname}
                            </span>
                          )} */}
                        </div>
                      </Grid>
                      <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
                        <div className="input-common">
                          <label>Email</label>
                          <TextField
                            fullWidth
                            id="fullWidth"
                            placeholder="Email"
                            name="email"
                            onChange={(e) => handleChange(e)}
                            value={allUsers.email}
                            onFocus={validateFocus}
                            onInput={validateFocus}
                            // onInput={validateFocus}

                            error={!!errors.email}
                            helperText={errors.email}
                          />
                          {/* {errors.email && (
                            <span className="error" style={{ color: "red" }}>
                              {errors.email}
                            </span>
                          )} */}
                        </div>
                      </Grid>
                      <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
                        <div className="input-common">
                          <label>Password</label>
                          <FormControl
                            sx={{ width: "100%" }}
                            variant="outlined"
                          >
                            <OutlinedInput
                              id="outlined-adornment-password"
                              type={showPassword ? "text" : "password"}
                              // value={password}
                              placeholder="*********"
                              error={!!errors.password}
                              // onChange={(e) => {
                              //   setPassword(e.target.value);
                              // }}
                              name="password"
                              onChange={(e) => handleChange(e)}
                              onFocus={(e) => validateFocus(e)}
                              value={allUsers.password}
                              onInput={validateFocus}
                              endAdornment={
                                <InputAdornment position="end">
                                  <IconButton
                                    className="eye-icon"
                                    aria-label={
                                      showPassword
                                        ? "hide the password"
                                        : "display the password"
                                    }
                                    onClick={handleClickShowPassword}
                                    edge="end"
                                  >
                                    {showPassword ? (
                                      <Visibility />
                                    ) : (
                                      <VisibilityOff />
                                    )}
                                  </IconButton>
                                </InputAdornment>
                              }
                            />
                          </FormControl>
                          <span
                            style={{
                              color: "#d32f2f",
                              fontSize: 13,
                              fontWeight: "bold",
                            }}
                          >
                            {errors.password}
                          </span>{" "}
                        </div>
                      </Grid>
                      <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
                        <div className="input-common">
                          <label>Confirm Password</label>
                          <FormControl
                            sx={{ width: "100%" }}
                            variant="outlined"
                          >
                            <OutlinedInput
                              id="outlined-adornment-password"
                              type={showConfirmPassword ? "text" : "password"}
                              // value={password}
                              placeholder="*********"
                              // onChange={(e) => {
                              //   setPassword(e.target.value);
                              // }}
                              // error={!!errors.confirmpassword}
                              name="confirmpassword"
                              onChange={(e) => handleChange(e)}
                              onFocus={(e) => validateFocus(e)}
                              value={allUsers.confirmpassword}
                              error={!!errors.confirmpassword}
                              onInput={validateFocus}
                              endAdornment={
                                <InputAdornment position="end">
                                  <IconButton
                                    className="eye-icon"
                                    aria-label={
                                      showPassword
                                        ? "hide the password"
                                        : "display the password"
                                    }
                                    // onClick={handleClickShowPassword}
                                    onClick={handleClickShowConfirmPassword}
                                    edge="end"
                                  >
                                    {showConfirmPassword ? (
                                      <Visibility />
                                    ) : (
                                      <VisibilityOff />
                                    )}
                                  </IconButton>
                                </InputAdornment>
                              }
                            />
                          </FormControl>
                          <span
                            style={{
                              color: "#d32f2f",
                              fontSize: 13,
                              fontWeight: "bold",
                            }}
                          >
                            {errors.confirmpassword}
                          </span>{" "}
                        </div>
                        <div className="credits display-1">
                          <Checkbox
                            {...label}
                            onClick={() => {
                              setAllUsers({
                                ...allUsers,
                                registercheck: true,
                              });
                              setCheck(!check);
                            }}
                            checked={check === true && check}
                            name="registercheck"
                          />
                          <p>
                            Creating an account means you’re okay with our{" "}
                            <Link>
                              <span>Terms of Service</span>
                            </Link>
                            , <span>Privacy Policy</span>, and our default{" "}
                            <span>Notification Settings</span>.
                          </p>
                        </div>
                        {/* {errors?.registercheck && (
                          <span style={{ color: "red" }}>
                            {errors.registercheck}
                          </span>
                        )} */}
                        <div className="common-btn text-center">
                          {/* <Button
                            type="submit"
                            fullWidth
                            sx={{ mt: 3, mb: 2 }}
                            // onClick={() => {
                            //   navigate("/");
                            // }}
                            onClick={handleSubmit}
                          >
                            Create Account
                          </Button> */}
                          {load ? (
                            <Button fullWidth sx={{ mt: 3, mb: 2 }}>
                              Processing...
                            </Button>
                          ) : (
                            <Button
                              type="submit"
                              fullWidth
                              sx={{ mt: 3, mb: 2 }}
                              // onClick={() => {
                              //   navigate("/");
                              // }}
                              onClick={handleSubmit}
                            >
                              Create Account
                            </Button>
                          )}
                        </div>
                      </Grid>
                    </Grid>

                    <div className="text-center alraedy mt-50">
                      <Link to="/login" variant="body2">
                        {"Already have an account? "}
                        <span>Login</span>
                      </Link>
                    </div>

                    {/* <Copyright sx={{ mt: 5 }} /> */}
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
    </>
  );
}
